import React, { useState, useRef, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './Modulos.css';
import Quiz from '../../Components/Quiz/Quiz';
import Modal from '../../Components/Modal/Modal';
import { ModuloApi } from '../../api/ModuloApi';
import { UsuarioModuloApi } from '../../api/UsuarioModuloApi';
import { CanalApi } from '../../api/CanalApi';
import { UserContext } from '../../App';

const canalApi = new CanalApi();

const Modulos = () => {
  const user = useContext(UserContext);
  const moduloApi = new ModuloApi();
  const modulousuarioapi = new UsuarioModuloApi();

  const [rating, setRating] = useState(0);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modulos, setModulos] = useState([]);
  const [moduleStatus, setModuleStatus] = useState([]);
  const [isRelationsChecked, setIsRelationsChecked] = useState(false);
  const videoRef = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchModulos = async () => {
    try {
      const data = await moduloApi.getAllModulo();
      setModulos(data);
      checkRelations(data);
    } catch (error) {
      console.error('Error fetching modulos:', error);
    }
  };

  const checkRelations = async (modulos) => {
    if (!isRelationsChecked && modulos.length > 0) {
      let statusArray = modulos.map(() => ({ unlocked: false, relationExists: false }));
      let lastUnlockedIndex = -1;
      for (let i = 0; i < modulos.length; i++) {
        try {
          const response = await modulousuarioapi.checkUsuarioModuloExists(user.id, modulos[i].id);
          const exists = response.exists !== 0;
          if (i === 0) {
            statusArray[i] = { unlocked: true, relationExists: exists };
            if (exists) lastUnlockedIndex = i;
          } else if (lastUnlockedIndex >= 0 && statusArray[lastUnlockedIndex].relationExists === true && !exists) {
            statusArray[i] = { unlocked: true, relationExists: exists };
            lastUnlockedIndex = i;
          } else {
            statusArray[i] = { unlocked: false, relationExists: exists };
          }
          if (statusArray[i].relationExists) statusArray[i].unlocked = true;
        } catch (error) {
          console.error(`Error checking relation for module ${modulos[i].modulo_name}:`, error);
        }
      }
      setModuleStatus(statusArray);
      setIsRelationsChecked(true);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchModulos(); }, []);

  const selectedModule = modulos.find(m => m.id === parseInt(id));
  const currentIndex = modulos.findIndex(m => m.id === parseInt(id));
  const completedCount = moduleStatus.filter(s => s?.relationExists).length;

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute('src');
      videoRef.current.load();
    }
  }, [id]);

  const goToPreviousModule = () => {
    if (currentIndex > 0) navigate(`/modulos/${modulos[currentIndex - 1].id}`);
  };

  const goToNextModule = async () => {
    const response = await modulousuarioapi.checkUsuarioModuloExists(user.id, modulos[currentIndex].id);
    const exists = response.exists !== 0;
    if (exists) {
      if (currentIndex < modulos.length - 1) navigate(`/modulos/${modulos[currentIndex + 1].id}`);
    } else {
      alert('Debes aprobar el test para continuar al siguiente módulo.');
    }
  };

  const handleQuizCompletion = async () => {
    const data = { id_usuario: user.id, id_modulo: selectedModule.id };
    await modulousuarioapi.InsertUserAprobado(data);
    canalApi.checkLogro(user.id).catch(() => {});
  };

  return (
    <div className={`modulos-container ${isSidebarCollapsed ? 'sidebar-off' : ''}`}>

      {/* ── Main content ── */}
      <div className="video-area">

        {/* Nav bar */}
        <div className="nav-bar">
          <button
            className="nav-btn"
            onClick={goToPreviousModule}
            disabled={currentIndex <= 0}
          >
            ← Anterior
          </button>
          {selectedModule && (
            <span className="nav-label">Módulo {selectedModule.modulo_name}</span>
          )}
          <button
            className="nav-btn"
            onClick={goToNextModule}
            disabled={currentIndex >= modulos.length - 1}
          >
            Siguiente →
          </button>
        </div>

        {/* Video */}
        {selectedModule ? (
          <video
            ref={videoRef}
            controls
            autoPlay
            key={selectedModule.modulo_url}
            className="main-video"
            poster="/Images/miniatura_video.png"
          >
            <source src={selectedModule.modulo_url} type="video/mp4" />
          </video>
        ) : (
          <div className="video-placeholder">
            <div className="placeholder-icon">▶</div>
            <p>Cargando módulo...</p>
          </div>
        )}

        {/* Meta card */}
        {selectedModule && (
          <div className="meta-card">
            <div className="meta-top">
              <div className="meta-info">
                <span className="module-badge">Módulo {selectedModule.modulo_name}</span>
                <h2 className="module-title">{selectedModule.modulo_description}</h2>
              </div>
              <div className="meta-actions">
                <div className="rating">
                  {[...Array(5)].map((_, i) => (
                    <button
                      key={i + 1}
                      type="button"
                      className={`star ${i + 1 <= rating ? 'on' : 'off'}`}
                      onClick={() => setRating(i + 1)}
                    >★</button>
                  ))}
                </div>
                <button className="test-button" onClick={() => setShowModal(true)}>
                  Realizar test
                </button>
              </div>
            </div>

            {selectedModule.modulo_large_description && (
              <p className="module-desc">{selectedModule.modulo_large_description}</p>
            )}
            <p className="module-tip">
              📝 Prepara papel y boli, asegúrate de estar en un lugar tranquilo y que empiece el juego!
            </p>
          </div>
        )}
      </div>

      {/* ── Sidebar toggle tab ── */}
      <button
        className="sidebar-tab"
        onClick={() => setIsSidebarCollapsed(p => !p)}
        title={isSidebarCollapsed ? 'Mostrar contenidos' : 'Ocultar contenidos'}
      >
        {isSidebarCollapsed ? '‹' : '›'}
      </button>

      {/* ── Sidebar ── */}
      <aside className={`sidebar ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-head">
          <span className="sidebar-title">Contenidos</span>
          <span className="sidebar-count">{completedCount}/{modulos.length}</span>
        </div>

        <div className="progress-track">
          <div
            className="progress-fill"
            style={{ width: modulos.length ? `${(completedCount / modulos.length) * 100}%` : '0%' }}
          />
        </div>

        <ul className="modules-list">
          {modulos.map((modulo, index) => {
            const isActive = modulo.id === parseInt(id);
            const done = moduleStatus[index]?.relationExists;
            const unlocked = moduleStatus[index]?.unlocked;
            return (
              <li
                key={modulo.id}
                className={`mod-item${isActive ? ' active' : ''}${done ? ' done' : ''}${!unlocked ? ' locked' : ''}`}
                onClick={() => unlocked && navigate(`/modulos/${modulo.id}`)}
                title={!unlocked ? 'Completa el módulo anterior para desbloquear' : undefined}
              >
                <div className={`mod-num${done ? ' done' : isActive ? ' active' : ''}`}>
                  {done ? '✓' : modulo.modulo_name}
                </div>
                <div className="mod-text">
                  <span className="mod-label">Módulo {modulo.modulo_name}</span>
                  {done && <span className="mod-status done">Completado</span>}
                  {!done && isActive && <span className="mod-status active">En curso</span>}
                  {!unlocked && <span className="mod-status locked">Bloqueado</span>}
                </div>
                {isActive && !done && <span className="mod-arrow">▶</span>}
              </li>
            );
          })}
        </ul>
      </aside>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <Quiz modulo={selectedModule?.id} onQuizComplete={handleQuizCompletion} />
      </Modal>
    </div>
  );
};

export default Modulos;
